module.exports = __webpack_public_path__ + "static/transparency_un-4ad563c832305a97faa7247a5d2617a2.png";